// supported special chars: _(underscore), @(at-symbol), -(hyphen), .(period)

export const specialCharsRegex = /[^a-zA-Z0-9@_.-]/gi;

export const removeUnsupportedSpecialChars = (value: string) => value.replace(/ *[^a-zA-Z0-9@._-]/gi, '');

export const testSpecialCharsRegex = (value: string) => specialCharsRegex.test(value);

export const isPolicyNumberEIS = (policyNumber: string) => /(^ACC|^CI|^HI)/i.test(policyNumber);